// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1lAhb","colMin":"styles_colMin__3xT7V","colCheckbox":"styles_colCheckbox__ycYzx"};